import script from "./TermsOfService.vue?vue&type=script&lang=ts&setup=true"
export * from "./TermsOfService.vue?vue&type=script&lang=ts&setup=true"

import "./TermsOfService.vue?vue&type=style&index=0&id=1091e9a0&scoped=true&lang=scss"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1091e9a0"]])

export default __exports__